import React from "react";
import { ModalContainer } from "@trodly/login-signup";

import baseStyle from "./base.module.css";
import EnquiryMount from "./components";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activity: {},
      location: {},
      openModal: false
    };
  }
  componentDidMount() {
    const { id, name, type, autoPop } = this.props;
    if (type === "activity") {
      this.setState({ activity: { id, name } });
    } else {
      this.setState({ location: { id, name } });
    }
  }
  render() {
    const { openModal, activity, location } = this.state;
    return (
      <>
        <div
          className={baseStyle.triggerButton}
          onClick={() => this.setState({ openModal: true })}
        />
        {openModal && (
          <ModalContainer
            close={() => this.setState({ openModal: false })}
            mount="lms-modal-root"
          >
            <EnquiryMount activity={activity} location={location} />
          </ModalContainer>
        )}
      </>
    );
  }
}

export default App;
